
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'JoinAgree',
  data() {
    return {
    }
  },
  components: {

  },
  methods: {
    goto_login(){
      this.$router.push("/login");
    }

  },

});
